var fbExportModule = angular.module('t2g.fbWidget', [
  'ui.router',
  require('t2g.common.services.modelService').name,
]);

module.exports = fbExportModule;

fbExportModule.config(function($stateProvider) {
  $stateProvider.state('private.main.fbWidget', {
    url: '/fbWidget',
    title: 'Facebook Widget',
    templateUrl: '/app/modules/fbWidget/FBWidgetView.html?v=4.5.6',
    controller: 'FBWidgetCtrl',
    resolve: {
      officeResolve: function(OfficeDA) {
        return OfficeDA.get();
      },
    },
  });
});

fbExportModule.controller('FBWidgetCtrl', function($scope, officeResolve) {
  $scope.office = officeResolve;
  $scope.widgetCode = 'appointments';

  $scope.$watch('widgetCode', function() {
    if ($scope.widgetCode == 'appointments') {
      setCode(
        'https://www.termin2go.com/appointment-booking/' +
          $scope.office.slug +
          '#/services?channel=facebook',
      );
    }

    if ($scope.widgetCode == 'courses') {
      setCode(
        'https://www.termin2go.com/kursbuchen#!/' +
          $scope.office.slug +
          '/auswahl?channel=facebook',
      );
    }
  });

  function setCode(code) {
    if ($scope.office.slug) {
      $scope.iframeCode = code;
    }
  }
});



// WEBPACK FOOTER //
// ./src/app/modules/fbWidget/fbWidgetModule.js